import { render, staticRenderFns } from "./GetDemographicInfo.vue?vue&type=template&id=50227e41&scoped=true"
import script from "./GetDemographicInfo.vue?vue&type=script&lang=js"
export * from "./GetDemographicInfo.vue?vue&type=script&lang=js"
import style0 from "./GetDemographicInfo.vue?vue&type=style&index=0&id=50227e41&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50227e41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VFlex,VForm,VLayout,VSelect,VTextField,VTextarea})
